import script from "./object_testimonial.vue?vue&type=script&setup=true&lang=js"
export * from "./object_testimonial.vue?vue&type=script&setup=true&lang=js"

import "./object_testimonial.vue?vue&type=style&index=0&id=9f4d8e20&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f4d8e20"]])

export default __exports__